import { useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
};


export const useMatchMediaDimensions = (width = 768, height = Infinity) => {
  const [isLess, setIsLess] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < width && window.innerHeight < height;
  });

  useEffect(() => {
    const handleResize = () => {
      const isWidthLess = window.innerWidth < width;
      const isHeightLess = window.innerHeight < height;
      setIsLess(isWidthLess && isHeightLess);
    };

    handleResize(); // run on mount

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width, height]);

  return isLess;
};

export default useWindowDimensions;
